import React from "react";

import { Button, InfoBar, type ManagedModalComponentProps, Modal } from "@shapr3d/frontend-lib";
import { upperFirst } from "es-toolkit";

import useTranslation from "../../../../../hooks/useTranslation";

import style from "./RemoveConfirmationModal.module.css";

interface RemoveConfirmationModalProps {
  modalProps: ManagedModalComponentProps;
  entity: string;
  isPending?: boolean;
  isError?: boolean;
  onConfirm: () => Promise<unknown>;
  action?: "deny" | "remove" | "leave";
}

export const RemoveConfirmationModal = React.forwardRef<HTMLElement, RemoveConfirmationModalProps>(
  (
    {
      modalProps,
      entity,
      isPending = false,
      isError = false,
      onConfirm,
      action = "remove",
    }: RemoveConfirmationModalProps,
    ref
  ) => {
    const { t, m } = useTranslation();

    const modalTitle = t(m.ShareModal.RemoveConfirmationModal.Title, {
      action,
      entity,
    });

    const modalDescription = t(m.ShareModal.RemoveConfirmationModal.Description, {
      action,
      entity,
    });

    const actionLabel = upperFirst(action);

    return (
      <Modal {...modalProps} size="small" title={modalTitle} ref={ref}>
        <div className={style.deleteConfirmationContainer}>
          <span>{modalDescription}</span>
          {isError && <InfoBar variant={"critical"} title={t(m.ErrorMessage.Unknown)} />}
          <Button
            variant={"red"}
            disabled={isPending}
            onClick={async () => {
              try {
                await onConfirm?.();
              } catch {
                // This is not to throw unhandled promise rejection error
              }
            }}
          >
            {actionLabel}
          </Button>
        </div>
      </Modal>
    );
  }
);
